// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './interface/environment.interface';

// @ts-ignore
export const environment: any = {
  // @ts-ignore
  production: true,
  // @ts-ignore
  apiUrl: 'https://user.web.svenn.com',
  sadminDomain: 'https://admin.svenn.com',
  type: 'user',
  SEGMENT_TOKEN: 'moqo961fxoURRxWOAgHmBsG6OtPLvBc6',
  VISMA_AUTHORIZE_URL: 'https://identity.vismaonline.com/connect/authorize',
  VISMA_AUTHORIZE_PARAMS: {
    'client_id': '24onoff',
    // @ts-ignore
    'redirect_uri': 'https://web.svenn.com/app/integrations/eaccounting-success/',
    // @ts-ignore
    'scope': 'ea:api%20offline_access%20ea:accounting%20ea:sales%20ea:purchase',
    // @ts-ignore
    'response_type': 'code',
    // @ts-ignore
    'prompt': 'login'
  },
  INTERCOM_APP_ID: 'qsibcja2',
  WEB_SOCKET_HOST: 'https://ws.prod.svenn.com/',
  HUBSPOT_SCRIPT_KEY: '9249003',
  PRODUCT_FRUITS_KEY: '0obwhnGnsoaXT2Ec',
  LAUNCH_DARCLY_CLIENT_ID: '64a2bca23075d41a9124755c',
  CKEDITOR_LICENSE_KEY: '',
  GOOGLE_CLIENT_ID: '545855489152-gcd5qiujshls1bbqcmhd066psb80e15c.apps.googleusercontent.com',
};

